/*
 * @Author: 黄智强
 * @Date: 2018-01-27 09:57:18
 * @Last Modified by: 黄智强
 * @Last Modified time: 2018-12-18 14:18:15
 * @说明：将所有接口地址导出
 */

import * as accountUrl from './account'
import * as regionUrl from './region'
import * as orderUrl from './order'
import * as authUrl from './auth'
import * as cartUrl from './cart'
import * as productUrl from './product'
import * as storeUrl from './store'
import * as verifyImageUrl from './verifyImage'
import * as fileUploadUrl from './fileUpload'
import * as payUrl from './pay'
import * as accountLogUrl from './accountLog'
import * as trialCardUrl from './trialCard'
import * as serviceUrl from './service'
import * as pocketUrl from './pocket'
import * as customerUrl from './customer'
import * as activityUrl from './activity'
import * as inviteUrl from './invite'
import * as notificationUrl from './notification'
import * as employeeUrl from './employee'

export default {
  accountUrl,
  regionUrl,
  orderUrl,
  authUrl,
  cartUrl,
  productUrl,
  storeUrl,
  verifyImageUrl,
  fileUploadUrl,
  payUrl,
  accountLogUrl,
  trialCardUrl,
  serviceUrl,
  pocketUrl,
  customerUrl,
  activityUrl,
  inviteUrl,
  notificationUrl,
  employeeUrl
}
